<div class="kanban-list"  *ngIf="list.isShowing">
  <div class="kanban-list-header">
    <div class="kanban-list-title">{{list.name}}</div>
  </div>
  <div class="kanban-cards" (mousedown)="$event.stopPropagation()" (scroll)="ListScroll($event,list)">
    <kanban-card *ngFor="let card of this.list.cards" [card]="card"></kanban-card>
  </div>
</div>
